import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MetricCardCollection } from '../../models/metric-cards.model';
import { MetricCardComponent } from '../metric-card/metric-card.component';

@Component({
    selector: 'emt-metric-card-collection',
    templateUrl: './metric-card-collection.component.html',
    styleUrls: ['./metric-card-collection.component.scss'],
    imports: [MetricCardComponent]
})
export class MetricCardCollectionComponent {
  @Input() metricCardCollection: MetricCardCollection;
  @Input()isCondensedMode:boolean;
  
  constructor() {}
}
